import { alterTags } from "./seo.js"

export default {
    data() {
        return {
            pagina: {},
            menu: [],
        }
    },
    async created() {
        await this.loadPage(this.$route.path)
    },
    async beforeRouteUpdate(to, from, next) {
        if ((to.name == 'pagina' || to.name == 'egressos' || to.name == 'prouni') && to.fullPath != from.fullPath) {
            await this.loadPage(to.path)
        }
        next()
    },
    methods: {
        async loadPage(path) {
            await this.$axios
                .get(`paginas${path}`)
                .then(response => {
                    this.pagina = response.data
                    this.loadMenu(path);
                    alterTags(this.pagina.seo_title, this.pagina.seo_description)
                })
                // eslint-disable-next-line
                .catch(error => {
                    this.$router.replace({ name: '404' })
                })
        },
        async loadMenu(path) {
            await this.$axios
                .get(`paginas/menu${path}`)
                .then(response => this.menu = response.data.menu)
        }
    },
}